export const generation = {
    labels: {
        generation: "Geração",
        generations: "Gerações",
        edit_generation: "Editar Geração",
    },
    placeholders: {
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
        description: "Informe a descrição",
    },
    modals: {
        titles: {
            add_generation: "Adicionar Geração",
            edit_generation: "Editar Geração",
            del_generation: "Excluir Geração",
        },
        messages: {
            del_generation: "Você deseja mesmo excluir a geração <strong>{name}</strong>?<br/>Todos os relacionamentos desta geração serão excluídos.",
        },
    },
    texts: {
    },
};
